var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metadata-drawer-launcher"},[_c('button',{attrs:{"type":"button","title":"Open metadata drawer","aria-label":"Open metadata drawer"},on:{"click":function($event){return _vm.setActiveComponent('plugin')}}},[_c('b-icon',{attrs:{"icon":"info-circle-fill","aria-hidden":"true"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }